import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, OnInit, ViewChild, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-nuestros-aliados',
  templateUrl: './nuestros-aliados.component.html',
  styleUrls: ['./nuestros-aliados.component.scss'],
  standalone: true,
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NuestrosAliadosComponent implements OnInit, AfterViewInit {

  @ViewChild('swiperEl', { static: false }) swiperEl!: ElementRef;
  @ViewChild('swiperEl2', { static: false }) swiperEl2!: ElementRef;

  partners: string[] = [
    '/assets/images/stone.webp',
    '/assets/images/american.webp',
    '/assets/images/bmi.webp',
    '/assets/images/rl360.webp',
    '/assets/images/redbridge.png',
    '/assets/images/bny.png',
    '/assets/images/interactive.png',
    '/assets/images/investors.png'
  ];

   certificaciones: string[]= [
    '/assets/images/securities.webp',
    '/assets/images/naic.webp',
    '/assets/images/cayman.webp',
    '/assets/images/finra.webp',
    '/assets/images/ocif.png',
    '/assets/images/isle.png',
  ];

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const swiper = this.swiperEl?.nativeElement;
      const swiper2 = this.swiperEl2?.nativeElement;
      if (swiper && typeof swiper.initialize === 'function') {
        swiper.initialize();
      }
      if (swiper2 && typeof swiper2.initialize === 'function') {
        swiper2.initialize();
      }
    }, 0);
  }
}
